/* eslint-disable no-irregular-whitespace */
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRecuperarAcesso } from '../../api/endpoints';
import { getTotem } from '../../api/apiFactory';
import { selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, fetchLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import { fecharModalTotemLogin, selectModal } from '../../app/slices/modalSlice';
import { definirSecretaria } from '../../app/slices/secretariasSlice';
import {
  ContainerJanela, Divisor, FormFooter, Linha,
} from '../../styles/base';
import {
  cnpj, cpf, email, isCNPJ, tel,
} from '../../util/mascaras';
import Botao from '../Botao/Botao';
import { AbaContainer } from '../Botao/BotaoEstilo';
import Carregar from '../Carregar/Carregar';
import FormControl from '../FormControl/FormControl';
import {
  Aviso, JanelaLogin, JanelaLoginTotem, LinkEmail, TituloModal,
} from './ModalLoginTotemEstilo';

const defaultValues = {
  Usuario: '',
  Senha: '',
  Email: '',
  CpfCnpj: '',
  Telefone: '',
};

const ModalLoginTotem = () => {
  const [recuperarSenha, setRecuperarSenha] = useState(false);
  const [recuperarCadastro, setRecuperarCadastro] = useState(false);
  const [emailLoginAtivo, setEmailLoginAtivo] = useState(true);
  const [emailRecuperarAtivo, setEmailRecuperarAtivo] = useState(true);
  const [carregando, setCarregando] = useState(false);
  const [cpfcnpjLoginAtivo, setCpfcnpjLoginAtivo] = useState(false);
  const [telefoneRecuperarAtivo, setTelefoneRecuperarAtivo] = useState(false);
  const [values, setValues] = useState(defaultValues);
  const [modulo, setModulo] = useState('');

  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosModal = useSelector(selectModal);
  const dadosCidade = useSelector(selectCidade);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  useEffect(() => {
    if (getTotem() === 'true') {
      document.getElementById('inputUsuarioEmail').focus();
      document.getElementById('inputUsuarioEmail').click();
    }
  }, []);

  const recuperarAcessoSenhaEmail = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`e-${values.Email}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }
    if (values.Email !== '') {
      setCarregando(false);
      alert.success('E-mail enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "E-mail".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const recuperarAcessoSenhaTelefone = async (event) => {
    event.preventDefault();
    setCarregando(true);
    const resposta = await fetchRecuperarAcesso(`t-${values.Telefone}`);

    if (resposta.Message === 'Nenhum registro foi encontrado.') {
      setCarregando(false);
      return alert.error('Nenhum registro foi encontrado.', { timeout: 5000 });
    }

    if (values.Telefone !== '') {
      setCarregando(false);
      alert.success('SMS enviado com sucesso.', { timeout: 5000 });
    } else {
      alert.error('Por favor, preencha o campo "Telefone".', { timeout: 5000 });
      setCarregando(false);
    }
    setCarregando(false);
    return setValues(defaultValues);
  };

  const entrarAnonimo = async () => {
    if (dadosModal.origem === 'manifestacao') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'o',
      }));
    }
    if (dadosModal.origem === 'sic') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 's',
      }));
    }
    if (dadosModal.origem === 'zeladoria') {
      await dispatch(await fetchLoginAnonimo({
        modulo: 'z',
      }));
    }

    if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic' || dadosModal.origem === 'zeladoria') {
      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));
    }

    dispatch(fecharModalTotemLogin());
  };

  const entrarCadastrado = async (event) => {
    event.preventDefault();
    setCarregando(true);

    if (!values.Usuario || !values.Senha) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('É necessário preencher todos os campos.', { timeout: 5000 });
    }

    const resposta = await dispatch(fetchLogin({
      username: values.Usuario,
      password: values.Senha,
    }));

    if (!values.Usuario) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (emailLoginAtivo && !values.Usuario.includes('@')) {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    if (resposta.payload === 'Credencial errada.') {
      dispatch(desfazerConexao());
      setCarregando(false);
      return alert.error('Acesso negado, por favor tente novamente.', { timeout: 5000 });
    }

    setCarregando(false);

    if (dadosModal.origem === 'manifestacao' || dadosModal.origem === 'sic' || dadosModal.origem === 'zeladoria') {
      dispatch(definirSecretaria({
        idSecretaria: dadosModal.secretaria.idSecretaria,
        nomeSecretaria: dadosModal.secretaria.nomeSecretaria,
        corSecretaria: dadosModal.secretaria.corSecretaria,
      }));
    }

    return dispatch(fecharModalTotemLogin());
  };

  if (recuperarCadastro) {
    return (
      <ContainerJanela>
        <JanelaLoginTotem>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fecharTotem
              onClick={() => dispatch(fecharModalTotemLogin())}
            />
          </Linha>

          <TituloModal>Solicitante - Sem acesso</TituloModal>

          <Divisor />

          <Aviso style={{ textAlign: 'center' }}>
            <b>Perdeu o acesso ou esqueceu o seu e-mail?</b>
            <br />
            <br />
            Entre em contato com o nosso suporte através do e-mail:
            {' '}
            <LinkEmail href="mailto: contato@webnets​.com.br">contato@webnets​.com.br</LinkEmail>
            {' '}
            informando o seu nome completo, CPF e a qual instituição está vinculado o cadastro.
            <br />
            <br />
            Retornaremos com as instruções para recuperar
            seu acesso em até 24 (vinte e quatro) horas úteis.
          </Aviso>

          <Divisor />

          <Divisor />

          <Botao
            label="Login"
            link
            onClick={() => {
              setRecuperarSenha(false);
              setRecuperarCadastro(false);
            }}
          />
        </JanelaLoginTotem>
      </ContainerJanela>
    );
  }

  if (recuperarSenha) {
    return (
      <ContainerJanela>
        <JanelaLoginTotem>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fecharTotem
              onClick={() => dispatch(fecharModalTotemLogin())}
            />
          </Linha>

          <TituloModal>Solicitante - Esqueci minha senha</TituloModal>

          <Divisor />

          <form>
            <AbaContainer aba style={{ justifyContent: 'space-around' }}>
              <div>
                <>
                  <Botao
                    aba
                    label="E-mail"
                    ativo={emailRecuperarAtivo}
                    onClick={() => {
                      setTelefoneRecuperarAtivo(false);
                      setEmailRecuperarAtivo(true);
                    }}
                  />
                  <Botao
                    aba
                    label="Celular"
                    ativo={telefoneRecuperarAtivo}
                    onClick={() => {
                      setTelefoneRecuperarAtivo(true);
                      setEmailRecuperarAtivo(false);
                    }}
                  />
                </>
              </div>
            </AbaContainer>

            <Divisor size="medio" />

            <Divisor size="medio" />

            {emailRecuperarAtivo ? (
              <FormControl
                idCampo="inputEmail"
                value={values.Email && email(values.Email)}
                label="E-mail"
                onChange={({ target }) => setVal('Email', target.value)}
              />
            ) : (
              <FormControl
                idCampo="inputTelefone"
                value={values.Telefone && tel(values.Telefone)}
                label="Celular"
                onChange={({ target }) => setVal('Telefone', target.value)}
              />
            )}

            <FormFooter style={{ justifyContent: 'space-between' }}>
              {carregando !== true
                ? (
                  <Botao
                    label="Enviar"
                    type="submit"
                    onClick={emailRecuperarAtivo ? recuperarAcessoSenhaEmail : recuperarAcessoSenhaTelefone}
                  />
                )
                : (
                  <Carregar
                    login
                  />
                )}
            </FormFooter>

          </form>

          <Divisor />

          {/* <Botao
              link
              label="Não tem mais acesso ao seu e-mail? Clique aqui."
              onClick={() => setRecuperarCadastro(true)}
            /> */}

          <Divisor border size="pequeno" />

          <Botao
            label="Login"
            link
            onClick={() => {
              setRecuperarSenha(false);
            }}
          />
        </JanelaLoginTotem>
      </ContainerJanela>
    );
  }

  return (
    <ContainerJanela>
      <JanelaLoginTotem>
        <Linha style={{ justifyContent: 'flex-end' }}>
          <Botao
            fecharTotem
            onClick={() => dispatch(fecharModalTotemLogin())}
          />
        </Linha>

        <TituloModal>Solicitante - Login</TituloModal>

        <Divisor />

        <form autoComplete="off">
          <AbaContainer aba style={{ justifyContent: 'space-around' }}>
            <div>
              <>
                <Botao
                  aba
                  label="E-mail"
                  ativo={emailLoginAtivo}
                  onClick={() => {
                    setCpfcnpjLoginAtivo(false);
                    setEmailLoginAtivo(true);
                    setValues({
                      ...values,
                      Usuario: '',
                    });
                  }}
                />
                <Botao
                  aba
                  label="CPF/CNPJ"
                  ativo={cpfcnpjLoginAtivo}
                  onClick={() => {
                    setCpfcnpjLoginAtivo(true);
                    setEmailLoginAtivo(false);
                    setValues({
                      ...values,
                      Usuario: '',
                    });
                  }}
                />
              </>
            </div>
          </AbaContainer>

          <Divisor size="medio" />

          <Divisor size="medio" />

          {emailLoginAtivo ? (
            <FormControl
              idCampo="inputUsuarioEmail"
              label="E-mail"
              value={values.Usuario && email(values.Usuario)}
              onChange={({ target }) => setVal('Usuario', target.value)}
              type="inputTotemModalEmail"
            />
          ) : (
            <>
              {values.Usuario && isCNPJ(values.Usuario)
                ? (
                  <FormControl
                    idCampo="inputCNPJ"
                    value={values.Usuario && cnpj(values.Usuario)}
                    label="CPF/CNPJ"
                    onChange={({ target }) => setVal('Usuario', target.value)}
                    type="inputCnpjTotem"
                  />
                ) : (
                  <FormControl
                    idCampo="inputCPF"
                    value={values.Usuario && cpf(values.Usuario)}
                    label="CPF/CNPJ"
                    onChange={({ target }) => setVal('Usuario', target.value)}
                    type="inputCnpjTotem"
                  />
                )}
            </>
          )}

          <FormControl
            idCampo="inputSenha"
            label="Senha"
            value={values.Senha}
            type="senhaTotem"
            onChange={({ target }) => setVal('Senha', target.value)}
          />

          <Divisor />

          <FormFooter style={{ justifyContent: 'space-between' }}>
            {carregando !== true
              ? (
                <Botao
                  label="Entrar"
                  type="submit"
                  onClick={entrarCadastrado}
                  style={{ width: 250, padding: '20px 50px', fontSize: 19 }}
                />
              )
              : (
                <Carregar
                  login
                />
              )}
            <Botao
              label="Esqueci minha senha"
              link
              style={{ fontSize: 19 }}
              onClick={() => {
                setRecuperarSenha(true);
              }}
            />
          </FormFooter>
        </form>

        <Divisor />

      </JanelaLoginTotem>
    </ContainerJanela>
  );
};

export default ModalLoginTotem;
